module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0023.jpg?v=a11bc01f";